<div class="container-fluid row_banner pb-5">
  <app-header></app-header>
  <div class="row row_banner_signin justify-content-center">
    <div class="col-lg-12" style="text-align: center; margin-top: 8%">
      <img
        src="../../assets/images/editorimages/paymentdone.svg"
        alt="donepayment"
      />
      <h3 style="margin-top: 1%">
        Account details have been verified. Please signin to continue.
      </h3>
      <p style="margin-top: 1%; font-size: 23px">
        You’ll receive a confirmation email shortly.
      </p>
      <button
        type="button"
        class="btn btn-dark"
        style="height: 50px; margin-top: 1%"
        id="homepagecheckgrammar"
        [routerLink]="['/signin']"
      >
        Sign in
      </button>
    </div>
  </div>
</div>
<app-footer></app-footer>
